import { connectRouter } from 'connected-react-router';

import { config } from '../config';

/**
 * Редьюсер модели
 */
export const reducer = connectRouter(config.history);
